import React from 'react';
import { Typography, Alert } from '@mui/material';
import FeeStructure from 'src/components/fee/FeeStructure';
import useStyles from './styles';
export default function NewFeeStructureTab() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    variant: "modal"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Are residents aware of the upcoming changes?"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Make sure you have notified your residents about upcoming changes to any of the listed fees below. Residents will recieve a system alert about the changes too.")), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(FeeStructure, null)));
}